import { initializeApp, getApps } from "firebase/app";
import { getStorage } from "firebase/storage";

// Legacy Firebase project (existing files)
const legacyFirebaseConfig = {
  apiKey: "AIzaSyAub0AqWllscOrw5w4iHjsqm9RSvfOhnwY",
  authDomain: "security-52ca4.firebaseapp.com",
  projectId: "security-52ca4",
  storageBucket: "security-52ca4.appspot.com",
  messagingSenderId: "932437076282",
  appId: "1:932437076282:web:936af3a7402edc950e0803",
  measurementId: "G-B7PMKXPN43",
};

// New Firebase project (for all new uploads)
const newFirebaseConfig = {
  apiKey: "AIzaSyBe1LhChcVw-hWDIvaFptwg5y5kD_Ypx-4",
  authDomain: "eis-docs.firebaseapp.com",
  projectId: "eis-docs",
  storageBucket: "eis-docs.firebasestorage.app",
  messagingSenderId: "831893787228",
  appId: "1:831893787228:web:73c2e098ce1df0cd3c8c99",
  measurementId: "G-JZLHZF4HLP",
};

const apps = getApps();

const legacyApp =
  apps.find((a) => a.name === "legacy") ||
  initializeApp(legacyFirebaseConfig, "legacy");

const newApp =
  apps.find((a) => a.name === "[DEFAULT]") ||
  (!apps.length ? initializeApp(newFirebaseConfig) : apps[0]);

// Use this for all new uploads
export const storage = getStorage(newApp);

// Use this as a fallback when reading old files
export const legacyStorage = getStorage(legacyApp);